module.exports = __webpack_public_path__ + "img/header-diamondJewelry@2x.54f47a7.jpg";